/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { toFixed } from 'ng/shared/utils/math.utils';

/**
 * @ngdoc constant
 * @type Function
 * @name gslbLocationAfterLoad
 * @param {Object} - GslbGeoLocation protobuf.
 * @returns {Object}
 * @description
 *
 *     Makes necessary modifications on the passed GslbGeoLocation object and returns it back.
 */
angular.module('aviApp').constant('gslbLocationAfterLoad', function(config) {
    if (!config || !config.location) {
        return config;
    }

    const { location } = config;

    if ('longitude' in location) {
        location.longitude = toFixed(location.longitude, 4);
    }

    if ('latitude' in location) {
        location.latitude = toFixed(location.latitude, 4);
    }

    return config;
});
